<template>
  <div class="choose-goods">
    <navbar ref="navbar" show-home title="信用购选品" />
    <div class="choose-goods-wrapper">
      <choose-goods-nav :nav-height="navHeight" :nav-list="navList" ref="chooseGoods"></choose-goods-nav>
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/NavBar'
import ChooseGoodsNav from '../../components/honorBuy/ChooseGoodsNav'
export default {
  name: 'chooseGoods',
  components: {
    Navbar,
    ChooseGoodsNav
  },
  data () {
    return {
      navList: []
    }
  },
  computed: {
    navHeight () {
      return (this.$refs.navbar && this.$refs.navbar.navbarHeight) || 44
    }
  },
  mounted () {
    this.getNavList().then(() => {
      if (!this.navList.length) {
        return false
      }
      this.$refs.chooseGoods.getGoodsListHandler(this.navList[0].id)
    })
  },
  methods: {
    async getNavList () {
      const res = await this.$axios.get('api/business/list')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.navList = data
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>
</style>
